/**
 * Chromium may reject with these messages when async message channels close
 * (extensions, built-in features, or other injected scripts). Not actionable app errors.
 */
const BROWSER_MESSAGE_PORT_SNIPPETS = [
  'message channel closed before a response was received',
  'a listener indicated an asynchronous response',
  'extension context invalidated',
] as const;

export function getErrorLikeMessage(reason: unknown): string {
  if (reason instanceof Error) {
    return reason.message;
  }
  if (typeof reason === 'string') {
    return reason;
  }
  if (reason && typeof reason === 'object' && 'message' in reason) {
    const m = (reason as { message?: unknown }).message;
    if (typeof m === 'string') {
      return m;
    }
  }
  return '';
}

export function isBenignBrowserMessagePortError(reason: unknown): boolean {
  const msg = getErrorLikeMessage(reason).toLowerCase();
  if (!msg) {
    return false;
  }
  return BROWSER_MESSAGE_PORT_SNIPPETS.some((s) => msg.includes(s));
}
